import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import {
  IngestedOrder,
  ReceivedOrder,
  IngestedOrdersQueryParams
} from '@model/ingested-order/ingested-order.model';
import { FilterOptionsResponse } from '@model/filter/filter-options.model';

export abstract class OrdersPort {
  abstract getOrders(params?: IngestedOrdersQueryParams): Observable<{
    orders: IngestedOrder[] | ReceivedOrder[];
    pagination: {
      page: number;
      size: number;
      total: number;
      totalPages: number;
    };
  }>;

  abstract getFilterOptions(): Observable<FilterOptionsResponse>;
}

export const ORDERS_PORT = new InjectionToken<OrdersPort>('OrdersPort');

export abstract class ReceivedOrdersPort extends OrdersPort {
  abstract finalSave(caseNumbers: string[]): Observable<{
    specimenCount: number;
    message: string;
    timestamp: string;
    username: string;
  }>;
}

export const RECEIVED_ORDERS_PORT = new InjectionToken<ReceivedOrdersPort>(
  'ReceivedOrdersPort'
);
